module.exports = __webpack_public_path__ + "img/main-bcg-mob.0ef602a.webp";